import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import FilesField from './filesField';

const enhance = compose(
  withNamespaces(['chat', 'common']),
);
export default enhance(FilesField);
